// extracted by mini-css-extract-plugin
export default {"rowHasBadge":"hE-z","smallCardRow":"iE-z","largeCardRow":"jE-z","productSearchRow":"kE-z","curatedRow":"lE-z"};